import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';

export const loadProducts = ImmutablePropTypes.contains({
  updatedProductId: PropTypes.string,
  amount: PropTypes.number,
  filter: PropTypes.object,
  type: PropTypes.string
});
